export default __webpack_public_path__ + "static/media/a5.15b7b2bf.png";